/* eslint-disable max-len */
import Swiper, { Pagination, Autoplay } from 'swiper';

/* eslint-disable no-unused-vars */
const qcSwiper = new Swiper('.qc-swiper', {
  modules: [Pagination, Autoplay],
  loop: true,
  pagination: {
    el: '.qc-swiper-pagination',
    clickable: true,
    type: 'bullets',
  },
  autoplay: true,
  slidesPerView: 'auto',
});
